/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProcessExcelFileCommandResult } from '../../models/process-excel-file-command-result';

export interface ApiProjectItemProcessExcelFilePost$Plain$Params {
      body?: {
'ExcelFile'?: Blob;
'ProjectId'?: string;
}
}

export function apiProjectItemProcessExcelFilePost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectItemProcessExcelFilePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ProcessExcelFileCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectItemProcessExcelFilePost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProcessExcelFileCommandResult>;
    })
  );
}

apiProjectItemProcessExcelFilePost$Plain.PATH = '/api/ProjectItem/ProcessExcelFile';
